import React, { useState, useEffect } from 'react';
import { HiVideoCamera } from 'react-icons/hi2';
import { FaRegImage } from "react-icons/fa";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const navigationItems = [
  {
    group: 'video',
    items: [
      {
        name: 'Create Video',
        href: '/dashboard/videos',
        icon: HiVideoCamera,
        type: 'button',
      },
      {
        name: 'Images',
        href: '/dashboard/images',
        icon: FaRegImage,
        type: 'tab',
      },
    ],
  },
];

export default function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsCollapsed(window.innerWidth < 1024);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={classNames(
      "flex flex-col flex-none gap-y-5 overflow-y-auto border-r border-gray-200 bg-white transition-all duration-300",
      isCollapsed ? "w-16 px-2" : "w-60 px-6"
    )}>
      <nav className="flex flex-1 flex-col pt-12">
        <ul role="list" className="flex flex-1 flex-col gap-y-5">
          {navigationItems.map((group) => (
            <li key={group.group} className="space-y-5">
              {group.items.map((item) => (
                <div key={item.name} className="mb-2">
                  {item.type === 'button' ? (
                    <div className="relative group">
                      <div className={`absolute -inset-1 rounded-md ${
                        item.name === 'Create Video' 
                          ? 'bg-gradient-to-r from-blue-500 to-purple-600'
                          : 'bg-gradient-to-r from-emerald-500 to-teal-500'
                      } opacity-50 blur`}></div>
                      <a
                        href={item.href}
                        className={`relative flex items-center gap-x-2 text-sm font-semibold leading-6 text-white rounded-md ${
                          item.name === 'Create Video'
                            ? 'bg-black hover:bg-gray-800'
                            : 'bg-gray-900 hover:bg-gray-700'
                        } ${isCollapsed ? 'justify-center p-2' : 'justify-center px-4 py-2'}`}
                      >
                        <item.icon className="h-5 w-5" aria-hidden="true" />
                        {!isCollapsed && item.name}
                        {isCollapsed && (
                          <div className="absolute left-full ml-2 hidden group-hover:block">
                            <div className="bg-gray-900 text-white text-sm rounded-md py-1 px-2 whitespace-nowrap">
                              {item.name}
                            </div>
                          </div>
                        )}
                      </a>
                    </div>
                  ) : (
                    <div className="relative group">
                      <a
                        href={item.href}
                        className={`flex items-center gap-x-4 text-sm font-semibold leading-6 text-gray-900 rounded-md hover:bg-gray-50 ${
                          isCollapsed ? 'justify-center p-2' : 'px-4 py-2'
                        }`}
                      >
                        <item.icon className="h-5 w-5" aria-hidden="true" />
                        {!isCollapsed && item.name}
                        {isCollapsed && (
                          <div className="absolute left-full ml-2 hidden group-hover:block">
                            <div className="bg-gray-900 text-white text-sm rounded-md py-1 px-2 whitespace-nowrap">
                              {item.name}
                            </div>
                          </div>
                        )}
                      </a>
                    </div>
                  )}
                </div>
              ))}
              {group.group === 'video' && <div className="border-t border-gray-200 mt-6"></div>}
            </li>
          ))}
        </ul>
      </nav>
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="hidden lg:flex items-center justify-center p-2 mb-4 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-md"
      >
        {isCollapsed ? <HiChevronRight className="h-5 w-5" /> : <HiChevronLeft className="h-5 w-5" />}
      </button>
    </div>
  );
}